import { Pipe, PipeTransform } from '@angular/core';
import { startCase } from 'lodash-es';

@Pipe({
  name: 'startCase',
  standalone: false,
})
export class StartCasePipe implements PipeTransform {
  transform(input: string): string {
    if (!input) {
      return '';
    }
    return startCase(input);
  }
}
